import { ol_events_condition, ol_Feature, ol_Map, ol_Observable_unByKey, ol_interaction, ol_layer } from "@omnia/exports/openlayers";
import { isFunction } from "../utils/utils";
import { Layer } from "./layer";
import { IMapSelectInteraction } from "./types";

export class MapSelectInteraction implements IMapSelectInteraction {

    private selectInteraction: ol_interaction.Select;
    private _selectWatcherKey: any;

    private selectableLayers: Layer[] = [];

    private selectedStyleProvider: (feature: any, resolution: any) => any;

    private _watchers: ((selectedFeatures: any[]) => void)[] = [];

    private _multiselect: boolean = false;


    constructor(private olmap: ol_Map, filter?: (feature: ol_Feature) => boolean) {

        this.selectInteraction = new ol_interaction.Select({

            condition: ol_events_condition.click,

            toggleCondition: e => this.handleToggleCondition(e),

            layers: (l: ol_layer.Layer) => this.checkSelectableLayer(l),

            filter,

            style: (feature, resolution) => this.getSelectedFeatureStyle(feature, resolution)

        });

        this._selectWatcherKey = this.selectInteraction.on("select", event => {
            this.updateSelection();
        });

        olmap.getInteractions().extend([this.selectInteraction]);

    }

    dispose() {

        if (this.olmap) {

            this._watchers = [];

            ol_Observable_unByKey(this._selectWatcherKey);

            this.olmap.removeInteraction(this.selectInteraction);

            this.selectInteraction = null;
            this.olmap = null;

        }

    }

    refresh() {

        const features = this.selectInteraction.getFeatures().getArray().slice()

        this.clearSelection(false)

        this.selectFeatures(features)

    }

    setLayers(layers: Layer[], resetSelection: boolean = true) {

        if (resetSelection) {
            this.clearSelection();
        }

        this.selectableLayers = layers || [];

    }

    addLayer(layer: Layer) {

        if (!this.selectableLayers.find(l => l == layer)) {
            this.selectableLayers.push(layer);
        }

    }

    removeLayer(layer: Layer) {

        this.selectableLayers.remove(l => l == layer);

    }

    private checkSelectableLayer(olayer: ol_layer.Layer) {

        let layer = this.selectableLayers.find((l) => l.mapLayer == olayer);

        let s = layer ? layer.selectable : false;

        return s;

    }

    getSelectedFeatureStyle(feature: any, resolution: any) {

        if (isFunction(this.selectedStyleProvider)) {

            return this.selectedStyleProvider(feature, resolution);

        }

    }

    setStyleProvider(provider: (feature: any, resolution: any) => any) {
        this.selectedStyleProvider = provider;
    }

    clearSelection(notify: boolean = true) {

        const features = this.selectInteraction.getFeatures()
        features.clear()

        if (notify) {
            this.updateSelection()
        }

    }

    selectFeatures(selection: any[]) {

        var features = this.selectInteraction.getFeatures();

        if (features.getLength() == selection.length) {

            if (selection.every((item, index) => features.item(index) == item)) {
                return;
            }

        }

        features.clear();
        features.extend(selection);

        this.updateSelection();

    }

    selectFeature(feature) {

        this.selectFeatures([feature]);

    }

    get active(): boolean {
        return this.selectInteraction.getActive();
    }

    set active(active) {
        this.selectInteraction.setActive(active);
    }

    updateSelection() {

        var selection = this.selectInteraction.getFeatures().getArray().slice();

        this._watchers.forEach(w => w(selection));

    }

    watchSelection(watcher: (selectedFeatures: any[]) => void) {

        if (!this._watchers.find(w => w == watcher)) {
            this._watchers.push(watcher);
        }

    }

    unwatchSelection(watcher: (selectedFeatures: any[]) => void) {
        this._watchers.remove(w => w == watcher);
    }

    get enableMultipleSelection() {
        return this._multiselect;
    }

    set enableMultipleSelection(value: boolean) {
        this._multiselect = value;
    }

    private handleToggleCondition(mapBrowserEvent): boolean {
        if (this._multiselect) return true;
        return ol_events_condition.shiftKeyOnly(mapBrowserEvent)
    }

    public getSelectedFeatures(): any[] {
        return this.selectInteraction.getFeatures().getArray().slice()
    }

    public getSelectedFeaturesCount(): number {
        return this.selectInteraction.getFeatures().getLength()
    }

}
